import React, { useState, useEffect } from 'react'
import http from 'axios'

import Header from './Header'
import buildCalendar from './buildCalendar'
import './styles.css'

import { withStyles } from '@mui/styles'
import { style } from 'styles'

import moment from 'moment'
import 'moment/locale/it'  // without this line it didn't work
moment.locale('it')

function Calendar({ classes, selectedDay, setSelectedDay, serviceId }) {

	// momentjs (take 5 week by default)
	const [calendar, setCalendar] = useState([])
	const [prevMonth, setPrevMonth] = useState(null)

	const [monthAvailability, setMonthAvailability] = useState([])

	// build calendar
	useEffect(() => {
		setCalendar(buildCalendar(selectedDay))

		const year = moment(selectedDay).format('YYYY')
		const currMonth = moment(selectedDay).format('MM')

		// Just to check if the new date value has changed month
		if (prevMonth != currMonth) {
			loadMonthAvailability(year, currMonth)
			setPrevMonth(currMonth)
		}
	}, [selectedDay])

	const loadMonthAvailability = async(year, currMonth) => {
		const monthAvailability = await http.get(`${window.__endpoint}/api/booking/monthAvailability?item_id=${serviceId}&year=${year}&month=${currMonth}`)
		setMonthAvailability(monthAvailability)
	}

	function isSelected(day) {
		return selectedDay.isSame(day, 'day')
	}

	function beforeToday(day) {
		return day.isBefore(new Date(), 'day')
	}

	function isToday(day) {
		return day.isSame(new Date(), 'day')
	}

	function dayStyles(day) {
		if (beforeToday(day)) return 'before'
		if (isSelected(day)) return 'selected'
		if (isToday(day)) return 'today'

		return ''
	}

	function handleSelectedDay(day) {
		setSelectedDay(day)
	}

	function changeMonth(monthToAdd) {
		setSelectedDay(selectedDay.clone().add(monthToAdd, 'month'))
	}

	const dayNames = ['lun', 'mar', 'mer', 'gio', 'ven', 'sab', 'dom']

	return (<div className={classes.calendar}>
		<Header selectedDay={selectedDay} changeMonth={changeMonth}/>

		<div className={classes.calendarBody}>
			<div className={classes.calendarDayNames}>
				{dayNames.map((dayName, i) => (
					<span key={i}>{dayName}</span>
				))}
			</div>

			{calendar.map((week, idx) => <div key={idx}>
				{week.map((day, iWeek) => <div key={iWeek} className={classes.calendarDay} onClick={() =>  !beforeToday(day) && handleSelectedDay(day) }>

					{/* Day square */}
					<div className={classes.calendarOnlyDay}>
						{dayStyles(day) == 'selected' ?
							<div className={classes.calendarSelected}>
								<div className={dayStyles(day)}>
									{day.format('D').toString()}
								</div>
							</div>
							:
							dayStyles(day) == 'before' ?
								<div className={classes.calendarBefore}>
									<div className={dayStyles(day)}>
										{day.format('D').toString()}
									</div>
								</div>
								:
								dayStyles(day) == 'today' ? <div className={classes.calendarToday}>
									<div className={dayStyles(day)}>
										{day.format('D').toString()}
									</div>
								</div>
									:
									<div>
										{day.format('D').toString()}
									</div>
						}
						{monthAvailability.map((month, y) => (
							month.date == moment(day).format('YYYY-MM-DD')
								?
								month.available == '0' || month.available == null
									? <div key={y} /> // Non ci sono orari in questo giorno
									: month.available == month.reserved ? !beforeToday(day) && <div key={y} className={classes.unavailabilityBar} /> : !beforeToday(day) && <div key={y} className={classes.availabilityBar} />
								:
								<div key={y} />
						))}
					</div>
				</div>)}
			</div>
			)}
		</div>
	</div>)
}

export default withStyles(style)(Calendar)
